document.addEventListener('click', async (e) => {
  const btn = e.target.closest('.load-more-btn');
  if (!btn) return;

  const nextUrl = btn.dataset.nextUrl;
  if (!nextUrl) return;

  btn.disabled = true;
  btn.setAttribute('aria-busy', 'true');

  try {
    const res = await fetch(nextUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');

    // Append only product <li ref="cards[]"> items
    const newCards = doc.querySelectorAll('li[ref="cards[]"]');
    const currentList = document.querySelector('li[ref="cards[]"]')?.closest('ul,ol');

    if (!currentList || !newCards.length) {
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
      return;
    }

    newCards.forEach((li) => {
      currentList.insertAdjacentHTML('beforeend', li.outerHTML);
    });

    // Update next page URL (from the newly fetched page)
    const newBtn = doc.querySelector('.load-more-btn');
    if (newBtn?.dataset?.nextUrl) {
      btn.dataset.nextUrl = newBtn.dataset.nextUrl;
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
    } else {
      document.querySelector('[data-load-more]')?.remove();
    }
  } catch (err) {
    console.error(err);
    btn.disabled = false;
    btn.removeAttribute('aria-busy');
  }
});
